import {palette} from "../common";

export default {
    styleOverrides: {
        root: {
            color: "#282828"
        }
    }
}
